module.exports = __webpack_public_path__ + "static/media/english.9887ad53.png";